import { render, staticRenderFns } from "./DialogCreateCourse.vue?vue&type=template&id=53943f2e&"
import script from "./DialogCreateCourse.vue?vue&type=script&lang=js&"
export * from "./DialogCreateCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports